import {HostService} from "../services/host/HostService";
import {createContext} from "react";

export const hostContext = createContext<HostService>(new HostService());
